import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'react-tooltip';
import editImg from '../assets/pencil.png';
import deleteImg from '../assets/delete.png';

/**
 * Reusable card action buttons: View Details, Edit, Delete.
 * Extracted to eliminate code duplication across EventsList and Category pages.
 */
const CardActions = ({ onViewDetails, onEdit, onDelete, showManageActions }) => (
    <div className='flex justify-between mt-3'>
        <button
            onClick={onViewDetails}
            className="bg-gray-700 hover:bg-gray-900 text-white px-4 py-2 rounded-lg font-medium transition-all duration-300 text-sm"
        >
            View Details
        </button>
        {showManageActions && (
            <div className='flex justify-between gap-2'>
                <button
                    data-tooltip-id="tooltip-edit"
                    className='bg-campus-border py-2 px-3 hover:bg-gray-200 rounded-lg transition-colors duration-200'
                    onClick={onEdit}
                >
                    <img src={editImg} width='15px' height='15px' alt='editIcon' />
                </button>
                <button
                    data-tooltip-id="tooltip-delete"
                    className='bg-campus-border py-2 px-3 hover:bg-gray-200 rounded-lg transition-colors duration-200'
                    onClick={onDelete}
                >
                    <img src={deleteImg} width='15px' height='15px' alt='deleteIcon' />
                </button>
                <Tooltip id="tooltip-edit" content="Edit" place="top" />
                <Tooltip id="tooltip-delete" content="Delete" place="top" />
            </div>
        )}
    </div>
);

CardActions.propTypes = {
    onViewDetails: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    showManageActions: PropTypes.bool,
};

CardActions.defaultProps = {
    showManageActions: true,
};

export default CardActions;
